// in dev, this makes Vite inject its client as this module's first dependency,
// so that global constant replacements are installed before any other module
// (including user hooks) evaluates. In build it's inert.
import.meta.hot;


import * as universal_hooks from '../../../src/hooks.ts';

export { matchers } from './matchers.js';

export const nodes = [
	() => import('./nodes/0'),
	() => import('./nodes/1'),
	() => import('./nodes/2'),
	() => import('./nodes/3'),
	() => import('./nodes/4'),
	() => import('./nodes/5'),
	() => import('./nodes/6'),
	() => import('./nodes/7'),
	() => import('./nodes/8'),
	() => import('./nodes/9'),
	() => import('./nodes/10'),
	() => import('./nodes/11'),
	() => import('./nodes/12'),
	() => import('./nodes/13'),
	() => import('./nodes/14'),
	() => import('./nodes/15'),
	() => import('./nodes/16'),
	() => import('./nodes/17'),
	() => import('./nodes/18'),
	() => import('./nodes/19'),
	() => import('./nodes/20'),
	() => import('./nodes/21'),
	() => import('./nodes/22'),
	() => import('./nodes/23'),
	() => import('./nodes/24'),
	() => import('./nodes/25'),
	() => import('./nodes/26'),
	() => import('./nodes/27'),
	() => import('./nodes/28'),
	() => import('./nodes/29'),
	() => import('./nodes/30'),
	() => import('./nodes/31'),
	() => import('./nodes/32'),
	() => import('./nodes/33'),
	() => import('./nodes/34'),
	() => import('./nodes/35'),
	() => import('./nodes/36'),
	() => import('./nodes/37'),
	() => import('./nodes/38'),
	() => import('./nodes/39'),
	() => import('./nodes/40'),
	() => import('./nodes/41'),
	() => import('./nodes/42'),
	() => import('./nodes/43'),
	() => import('./nodes/44'),
	() => import('./nodes/45'),
	() => import('./nodes/46'),
	() => import('./nodes/47'),
	() => import('./nodes/48'),
	() => import('./nodes/49'),
	() => import('./nodes/50'),
	() => import('./nodes/51'),
	() => import('./nodes/52'),
	() => import('./nodes/53'),
	() => import('./nodes/54'),
	() => import('./nodes/55'),
	() => import('./nodes/56'),
	() => import('./nodes/57'),
	() => import('./nodes/58'),
	() => import('./nodes/59'),
	() => import('./nodes/60'),
	() => import('./nodes/61'),
	() => import('./nodes/62'),
	() => import('./nodes/63'),
	() => import('./nodes/64'),
	() => import('./nodes/65'),
	() => import('./nodes/66'),
	() => import('./nodes/67'),
	() => import('./nodes/68'),
	() => import('./nodes/69'),
	() => import('./nodes/70'),
	() => import('./nodes/71'),
	() => import('./nodes/72'),
	() => import('./nodes/73'),
	() => import('./nodes/74'),
	() => import('./nodes/75'),
	() => import('./nodes/76'),
	() => import('./nodes/77'),
	() => import('./nodes/78'),
	() => import('./nodes/79'),
	() => import('./nodes/80'),
	() => import('./nodes/81'),
	() => import('./nodes/82'),
	() => import('./nodes/83'),
	() => import('./nodes/84'),
	() => import('./nodes/85'),
	() => import('./nodes/86'),
	() => import('./nodes/87'),
	() => import('./nodes/88'),
	() => import('./nodes/89'),
	() => import('./nodes/90'),
	() => import('./nodes/91'),
	() => import('./nodes/92'),
	() => import('./nodes/93'),
	() => import('./nodes/94'),
	() => import('./nodes/95'),
	() => import('./nodes/96'),
	() => import('./nodes/97'),
	() => import('./nodes/98'),
	() => import('./nodes/99'),
	() => import('./nodes/100'),
	() => import('./nodes/101'),
	() => import('./nodes/102'),
	() => import('./nodes/103'),
	() => import('./nodes/104'),
	() => import('./nodes/105'),
	() => import('./nodes/106'),
	() => import('./nodes/107'),
	() => import('./nodes/108'),
	() => import('./nodes/109'),
	() => import('./nodes/110')
];

export const server_loads = [];

export const dictionary = {
		"/(marketing)": [8,[2]],
		"/404": [15],
		"/admin": [16,[3]],
		"/admin/alquiler": [17,[3]],
		"/admin/alquiler/editar": [18,[3]],
		"/admin/alquiler/pendientes": [19,[3]],
		"/admin/alquiler/pendientes/verificacion": [20,[3]],
		"/admin/alquiler/reservas": [21,[3]],
		"/admin/barcos": [22,[3]],
		"/admin/barcos/barco": [23,[3]],
		"/admin/capitanes": [24,[3]],
		"/admin/destacados": [25,[3]],
		"/admin/experiencias": [26,[3]],
		"/admin/experiencias/editar": [27,[3]],
		"/admin/experiencias/experiencias-pendientes": [28,[3]],
		"/admin/experiencias/experiencias-pendientes/verificacion": [29,[3]],
		"/admin/experiencias/reservas": [30,[3]],
		"/admin/lista6/pendientes": [31,[3]],
		"/admin/lista6/pendientes/verificacion": [32,[3]],
		"/admin/pedidos": [33,[3]],
		"/admin/pedidos/pedido": [34,[3]],
		"/admin/presupuestos": [35,[3]],
		"/admin/proyectos": [36,[3]],
		"/admin/proyectos/actividades": [37,[3]],
		"/admin/reportados": [38,[3]],
		"/admin/revisiones": [39,[3]],
		"/admin/revisiones/resultado": [40,[3]],
		"/admin/revisiones/revision": [41,[3]],
		"/admin/usuarios": [42,[3]],
		"/admin/usuarios/usuario": [43,[3]],
		"/admin/valoraciones": [44,[3]],
		"/alquiler-barco": [45],
		"/alquiler-barco/confirmacion": [46],
		"/(marketing)/alquiler-lista-septima": [9,[2]],
		"/(marketing)/alquiler-lista-sexta": [10,[2]],
		"/(marketing)/anadir-barco": [11,[2]],
		"/aviso-legal": [47],
		"/barcos/[...segments]": [48],
		"/bienvenido-cofrade": [49],
		"/checkout": [50],
		"/confirmar-suscripcion": [51],
		"/contacto": [52],
		"/cuenta": [53,[4]],
		"/cuenta/alquiler": [54,[4]],
		"/cuenta/alquiler/anuncio": [55,[4]],
		"/cuenta/alquiler/confirmacion-reserva": [56,[4]],
		"/cuenta/alquiler/publicar-anuncio/anuncio": [57,[4,5]],
		"/cuenta/alquiler/publicar-anuncio/barco": [58,[4,5]],
		"/cuenta/alquiler/publicar-anuncio/capitan": [59,[4,5]],
		"/cuenta/alquiler/publicar-anuncio/confirmacion": [60,[4,5]],
		"/cuenta/alquiler/publicar-anuncio/precio": [61,[4,5]],
		"/cuenta/alquiler/publicar-anuncio/revisar": [62,[4,5]],
		"/cuenta/alquiler/reservas": [63,[4]],
		"/cuenta/alquiler/reservas/reserva": [64,[4]],
		"/cuenta/barcos": [65,[4]],
		"/cuenta/barcos/barco": [66,[4]],
		"/cuenta/experiencias": [67,[4]],
		"/cuenta/experiencias/experiencia": [68,[4]],
		"/cuenta/experiencias/publicar-experiencia": [69,[4,6]],
		"/cuenta/experiencias/publicar-experiencia/anuncio": [70,[4,6]],
		"/cuenta/experiencias/publicar-experiencia/armador": [71,[4,6]],
		"/cuenta/experiencias/publicar-experiencia/barco": [72,[4,6]],
		"/cuenta/experiencias/publicar-experiencia/precio": [73,[4,6]],
		"/cuenta/experiencias/publicar-experiencia/revisar": [74,[4,6]],
		"/cuenta/experiencias/reservas": [75,[4]],
		"/cuenta/experiencias/reservas/reserva": [76,[4]],
		"/cuenta/favoritos": [77,[4]],
		"/cuenta/informacion-personal": [78,[4]],
		"/cuenta/lista6/publicar-anuncio": [79,[4,7]],
		"/cuenta/lista6/publicar-anuncio/anuncio": [80,[4,7]],
		"/cuenta/lista6/publicar-anuncio/armador": [81,[4,7]],
		"/cuenta/lista6/publicar-anuncio/barco": [82,[4,7]],
		"/cuenta/lista6/publicar-anuncio/precio": [83,[4,7]],
		"/cuenta/lista6/publicar-anuncio/revisar": [84,[4,7]],
		"/cuenta/pagos": [85,[4]],
		"/cuenta/presupuestos": [86,[4]],
		"/cuenta/proyectos": [87,[4]],
		"/cuenta/proyectos/actividades": [88,[4]],
		"/cuenta/reservas": [89,[4]],
		"/cuenta/reservas/reserva": [90,[4]],
		"/cuenta/revisiones": [91,[4]],
		"/cuenta/revisiones/detalles": [92,[4]],
		"/cuenta/seguridad": [93,[4]],
		"/cuenta/sistema-zarpar": [94,[4]],
		"/cuenta/sistema-zarpar/detalles": [95,[4]],
		"/cuenta/suscripcion": [96,[4]],
		"/experiencia": [97],
		"/experiencia/confirmacion": [98],
		"/experiencia/valoracion": [99],
		"/iniciar-sesion": [100],
		"/perfil/[username]": [101],
		"/politica-de-cookies": [102],
		"/politica-de-privacidad": [103],
		"/preguntas-frecuentes": [104],
		"/recuperacion-credenciales": [105],
		"/(marketing)/regala-zarpar": [12,[2]],
		"/regala-zarpar/tarjeta-regalo": [106],
		"/(marketing)/registro-capitan": [13,[2]],
		"/registro": [107],
		"/reportar-anuncio": [108],
		"/terminos-tarjeta-regalo": [109],
		"/terminos-y-condiciones": [110],
		"/(marketing)/zarpar-experiencias": [14,[2]]
	};

export const hooks = {
	handleError: (({ error }) => { console.error(error) }),
	
	reroute: universal_hooks.reroute || (() => {}),
	transport: universal_hooks.transport || {}
};

export const decoders = Object.fromEntries(Object.entries(hooks.transport).map(([k, v]) => [k, v.decode]));
export const encoders = Object.fromEntries(Object.entries(hooks.transport).map(([k, v]) => [k, v.encode]));

export const hash = false;

export const decode = (type, value) => decoders[type](value);

export { default as root } from '../root.js';

export const get_error_template = () => import('../shared/error-template.js').then(m => m.default);